/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import clsx from 'clsx'
import {useLayout} from '../../core'
import {AsideTabs} from './AsideTabs'

import {DrawerComponent, ToggleComponent} from '../../../assets/ts/components'

const AsideDefault = () => {
  const {classes} = useLayout()
  const [link, setLink] = useState<string>('dashboard')

  useEffect(() => {
    setTimeout(() => {
      DrawerComponent.reinitialization()
      ToggleComponent.reinitialization()
    }, 50)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div
      id='kt_aside'
      className={clsx('aside', classes.aside.join(' '))}
      data-kt-drawer='true'
      data-kt-drawer-name='aside'
      data-kt-drawer-activate='{default: true, lg: false}'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width='auto'
      data-kt-drawer-direction='start'
      data-kt-drawer-toggle='#kt_aside_toggle'
    >
      <div className='aside-primary d-flex flex-column align-items-lg-center flex-row-auto position-relative'>
        <div
          className='aside-nav d-flex flex-column align-items-center flex-column-fluid'
          id='kt_aside_nav'
        >
          <AsideTabs link={link} setLink={setLink} />
        </div>
      </div>
    </div>
  )
}

export {AsideDefault}
